module.exports = __webpack_public_path__ + "static/media/tab-icon-home.5a3a6c67.svg";